var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fb-cls-1{fill:#347ae9;}.fb-cls-2{fill:#fff;}")),React.createElement("title",{"key":1},"mask map 06"),React.createElement("g",{"id":"text","key":2},[React.createElement("circle",{"className":"fb-cls-1","cx":"95.44","cy":"95.44","r":"95.44","key":0}),React.createElement("path",{"className":"fb-cls-2","d":"M104.15,154.36V101.92h17.6l2.64-20.43H104.15v-13c0-5.92,1.64-9.95,10.13-9.95H125.1V40.21a144.22,144.22,0,0,0-15.77-.81c-15.6,0-26.29,9.53-26.29,27V81.49H65.4v20.43H83v52.44Z","key":1})])]);
}

Facebook.defaultProps = {"viewBox":"0 0 190.88 190.88"};

module.exports = Facebook;

Facebook.default = Facebook;
